{
  "verified": "Ellenőrzött",
  "iv_status": {
    "verified": "Ellenőrzött",
    "pending": "Pending",
    "attention": "Figyelem"
  },
  "zoom_in": "Nagyítás",
  "zoom_out": "Kicsinyítés",
  "rotate": "Forgassa el a",
  "close": "Zárja be a",
  "esc_to_close": "Nyomja meg az ESC gombot a bezáráshoz",
  "play": "Játsszon",
  "pause": "Szünet",
  "mute": "Mute",
  "unmute": "Unmute",
  "enter_full_screen": "Teljes képernyő belépése",
  "exit_full_screen": "Kilépés teljes képernyőn",
  "video_not_supported": "Az Ön böngészője nem támogatja a videó tag-et.",
  "skip_forward": "Ugrás előre",
  "skip_backward": "Ugrás visszafelé",
  "loading": "Betöltés",
  "loading_video": "Videó betöltése...",
  "loading_data_description": "Kérjük, várjon, amíg betöltjük az adatokat. Ez nem tart sokáig.",
  "no_results": "Nincs eredmény",
  "nothing_found": "Semmit sem találtunk",
  "save_changes": "Változások mentése",
  "saved_exclamation": "Megmentve!",
  "saving": "Mentés",
  "validating": "A  oldal hitelesítése",
  "error": "Hiba",
  "optional": "Opcionális",
  "search_property": "Keresés ingatlan",
  "reset_search": "Keresés visszaállítása",
  "no_items_to_show": "Nincsenek megjelenítendő elemek",
  "showing_range_of_total_items": "A {{range}} a {{total}} elemek {{range}} elemeit mutatja.",
  "rows_per_page": "Sorok oldalanként",
  "page_of_pages": "Oldal {{page}} a {{pages}} oldalról",
  "go_to_first_page": "Menj az első oldalra",
  "go_to_previous_page": "Vissza az előző oldalra",
  "go_to_next_page": "Tovább a következő oldalra",
  "go_to_last_page": "Menj az utolsó oldalra",
  "sort_in_asc": "Rendezés növekvő sorrendben",
  "sort_in_desc": "Rendezés csökkenő sorrendben",
  "sort_a_z": "A → Z rendezése",
  "sort_z_a": "Válogassuk meg Z → A",
  "clear_sorting": "Tiszta válogatás",
  "reach_us_at_email": "Érjen el támogatást a support@chekin.com címen.",
  "please_wait": "Kérjük, várjon",
  "feature_coming_soon": "Hamarosan",
  "feature_coming_soon_description": "Ez a funkció jelenleg fejlesztés alatt áll, és hamarosan elérhető lesz. Maradjon velünk a frissítésekért!",
  "download_all": "Minden letöltése",
  "entry_forms": "Nevezési űrlapok",
  "tutorial": "Tutorial",
  "liveness_video": "Liveness videó",
  "beta": "Béta",
  "reviews": "Vélemények",
  "learn_more": "Tudjon meg többet",
  "this_cannot_be_reverted": "Ezt nem lehet visszaállítani",
  "delete": "Törölje a  címet.",
  "cancel": "Törölje",
  "you_have_made_changes": "Változtatásokat hajtott végre",
  "would_you_like_to_save_them": "Szeretné megmenteni őket?",
  "save": "Mentés",
  "dont_save": "Ne mentsd el",
  "copied_exclamation": "Másolom!",
  "search_placeholder": "Keresés...",
  "type_to_search": "Kereséshez írja be...",
  "loading_more": "Betöltés...",
  "no_options": "Nincsenek lehetőségek",
  "select_option": "Válassza ki az opciót",
  "clear_all": "Mindent törölni",
  "remove_item": "A {{label}} eltávolítása",
  "upload_file": "Fájl feltöltése",
  "download_attachment": "Melléklet letöltése",
  "remove_file": "Fájl eltávolítása",
  "open_calendar": "Nyílt naptár",
  "clear_dates": "Tiszta dátumok",
  "select_dates": "Válassza ki a dátumokat",
  "pick_date_range": "Válasszon egy dátumtartományt",
  "from": "A  címről",
  "to": "A  címre.",
  "pick_month": "Válasszon egy hónapot",
  "pick_date": "Válasszon egy időpontot",
  "month": "Hónap",
  "day": "Nap",
  "year": "Év",
  "done": "Kész",
  "wrong_period_of_dates": "A kiválasztott időszak érvénytelen",
  "date_range_max_days_error_one": "A tartomány nem haladhatja meg a {{count}} napot.",
  "date_range_max_days_error_other": "A tartomány nem haladhatja meg a {{count}} napot.",
  "date_range_min_days_error_one": "A tartománynak legalább {{count}} napnak kell lennie.",
  "date_range_min_days_error_other": "A tartománynak legalább {{count}} napnak kell lennie.",
  "past_dates": "A dátum nem lehet a {{minDate}}__ előtt.",
  "future_dates": "A dátum nem lehet {{maxDate}}__ után.",
  "signature_placeholder_text": "Írja alá a dobozon belül.<br/> Használja az ujját.<br/> Koppintson az indításhoz.",
  "open_devices_camera": "Nyissa meg a készülék kameráját",
  "place_document_inside_frame": "Helyezze a dokumentumot a keretbe",
  "close_other_application_that_may_be_using_your_camera": "Zárjon be más alkalmazásokat, amelyek esetleg a kamerát használják",
  "if_you_use_external_camera_disconnect_and_reconnect": "Ha külső kamerát használ, válassza ki és csatlakoztassa újra.",
  "close_the_browser_re_open_it": "Zárja be a böngészőt, majd nyissa meg újra",
  "camera_errors": {
    "experiencing_camera_issues": "Kameraproblémák?",
    "chekin_cant_use_your_camera": "Chekin nem tudja használni a kamerát",
    "please_try_a_different_browser": "A kamerája nem működik ebben a böngészőben. Kérjük, próbálja meg megnyitni a linket egy másik böngészőben.",
    "permissions_denied": "Engedély megtagadva",
    "camera_permissions_denied": "A kamera nem nyílik ki? Győződjön meg róla, hogy engedélyezi a böngésző számára a kamera használatát.",
    "no_camera_device_found": "Nem találtunk kameraeszközt. Kérjük, csatlakoztasson egy kamerát.",
    "constraints_camera_error": "A rendelkezésre álló eszközök nem tudják teljesíteni a korlátozásokat.",
    "safari_camera_error": "A Safari nem tudott megfelelni a kamerakövetelményeknek",
    "try_chrome_or_firefox": "Kérjük, próbálja ki a Chrome vagy Firefox programot"
  },
  "clear": "Tiszta",
  "show_less": "Kevesebb mutatása",
  "show_more": "Többet mutasson",
  "tap_here_to_sign": "Koppintson ide az aláíráshoz",
  "click_here_to_sign": "Kattintson ide az aláíráshoz",
  "prefix": "Előtag",
  "prefix_required": "Előtag szükséges",
  "reset": "Reset",
  "show_password": "Jelszó megjelenítése",
  "hide_password": "Jelszó elrejtése",
  "increment": "Inkrementálás",
  "decrement": "Csökkentés",
  "create_option": "Hozzon létre \"{{input}}__\"",
  "year_out_of_range": "Az évnek {{min}} és {{max}} között kell lennie.",
  "clear_date": "Tiszta dátum",
  "select_date": "Válassza ki a dátumot",
  "draw_signature_here": "Írja alá itt",
  "signature_hint": "Használd az egeret vagy az ujjadat",
  "clear_signature": "Egyértelmű aláírás",
  "draw_signature_here_mobile": "Írja alá!",
  "signature_hint_mobile": "Használd az ujjadat",
  "camera_access_needed": "A kamera hozzáférésére van szükség",
  "camera_access_needed_text": "Engedélyezze a kamera használatát a fénykép elkészítéséhez. Ha a kamera használata letiltva van, engedélyezze azt a böngésző beállításaiban, majd próbálja meg újra.",
  "dialog": "Párbeszéd"
}
